<div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
        <div class="w-full lg:w-4/12 px-4">
            <div
                class="relative flex flex-col min-w-0 break-words w-full mb-6 ">
                <img src="../../../../assets/img/forbidden.png" alt="">
                <h2 class="text-white text-center text-xl my-6">
                    دسترسی شما به این سایت محدود شده است
                </h2>
            </div>

                <div class="flex flex-wrap content-center mt-6 relative">
                    <div class="text-center">
                        <a (click)="logout()" class="cursor-pointer text-blueGray-200">
                            خروج
                        </a>
                        <!-- <a class="text-blueGray-200">
                            <small> 
                                فرادید مدیس &copy;
                                {{date | date: 'yyyy'}}
                            </small>
                        </a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>